import * as e from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/ListNumbers.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: m }));
o.displayName = "ListNumbersIcon";
const c = o;
export {
  c as ListNumbers,
  o as ListNumbersIcon
};
